/* eslint-disable @typescript-eslint/no-explicit-any */
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/core/accordion";
import { Minus, Plus } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import GradientBorder from "@/components/common/gradient-border";

const FAQItem = ({ faq }: any) => {
  return (
    <AccordionItem
      key={faq.id}
      value={faq.documentId}
      className="relative rounded-[1.25rem] bg-foreground p-4 backdrop-blur-md sm:p-6"
    >
      <GradientBorder radius="20" />

      <AccordionTrigger className="flex w-full flex-col py-0.5">
        <div className="flex w-full items-center justify-between gap-4 text-start">
          <div className="text-gold-light ml-2">{faq.title}</div>
          <div className="flex-shrink-0">
            <div className="flex h-5 w-5 items-center justify-center rounded-full border border-secondary">
              <Plus className="block h-4 w-4 text-zinc-950 transition-transform duration-200 group-data-[expanded]:hidden dark:text-zinc-50" />
              <Minus className="hidden h-4 w-4 text-zinc-950 transition-transform duration-200 group-data-[expanded]:block dark:text-zinc-50" />
            </div>
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-2 text-secondary/40">
        <div className="flex flex-col gap-4 pt-4 text-sm sm:text-base">
          <Separator className="bg-gold-medium" />
          <p className="font-opensans font-normal text-gold-medium">{faq.description}</p>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};

export default FAQItem;
